<form [formGroup]="settingsForm" (ngSubmit)="submit()"
    *ngIf="showSettings">
    <!--<div class="refresh-settings-pb">
        <div  (click)="refreshSettings($event)"><i class="bi bi-arrow-clockwise"></i></div>
      </div>-->
      <div class="row p-4">
      <!-- <div *ngIf="user.roleId !== 1 || (user.roleId === 1  && entity.entityTypeId !== 1)  " class="row p-4"> -->
        <div class="col-6">
            <div class="row mb-3">
                <label [for]="'language-' + entity.id" class="col-sm-5 col-form-label">{{'COMMON.LANGUAGES.TITLE' |translate }}</label>
                <div class="col-sm-7">
                <select class="form-select" [id]="'language-' + entity.id" formControlName="language">
                    <option *ngFor="let language of utils.languages_mimesys" [value]="language.value">{{('COMMON.LANGUAGES.' +
                      language.name) |translate}}</option>
                  </select>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="entity.entityTypeId === 4" class="row p-4">
        <div class="col-12">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">{{
                'SETTING.MIMESYS.APPCREDENTIALS.HEADER' | translate }}</h4>
        </div>
        <div class="col-12">
            <div class="row">
                <label [for]="'logo1'" class="col-sm-2 col-form-label">{{
                    'SETTING.MIMESYS.APPCREDENTIALS.USER' | translate }}</label>
                <div class="col-sm-4">
                    <input class="form-text-input" type="text" [id]="'appUser'" formControlName="appUser" readonly>
                </div>
                <label [for]="'logo1'" class="col-sm-2 col-form-label">{{
                    'SETTING.MIMESYS.APPCREDENTIALS.PWD' | translate }}</label>
                <div class="col-sm-4">
                    <input class="form-text-input" type="text" [id]="'appPwd'" formControlName="appPwd"
                        readonly><!--type="password"-->
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="(user.roleId === 1 && entity.entityTypeId === 1) || (entity.entityTypeId === 2 || entity.entityTypeId === 3)" class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">App Frontend Design - Welcome Menu</h4>
            <div class="row mb-3">
                <label [for]="'mimesysProductLogo'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.WELCOMEMENU.LABEL2' | translate }}
                    <hbo-field-info-icon fieldName="mimesysProductLogo"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage && !settingsForm.disabled"
                        (click)="clearImage($event,'mimesysProductLogo')" class="clear-pb"><i
                            class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage  && !(maxFileSizeExceed['mimesysProductLogo'] || fileExtError['mimesysProductLogo'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage)" class="image-link"
                        [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a>
                </label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'mimesysProductLogo'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage &&
                                        currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoName
                                        ? currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'mimesysProductLogo-' + entity.id"
                            formControlName="mimesysProductLogo" (change)="uploadFile($event,'mimesysProductLogo')">
                        <hbo-field-validation fieldName="mimesysProductLogo"></hbo-field-validation>
                    </div>
                </div>
            </div>
            <div *ngIf="hasLens() && hasCoach()" class="row mb-3">
                <label [for]="'lensLogo'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.WELCOMEMENU.LABEL3' | translate }}
                    <hbo-field-info-icon fieldName="lensLogo"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.lensLogo?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'lensLogo')" class="clear-pb"><i
                            class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.lensLogo?.logoImage  && !(maxFileSizeExceed['lensLogo'] || fileExtError['lensLogo'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.lensLogo?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a>
                </label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'lensLogo'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.lensLogo?.logoImage &&
                                        currentSettings?.appFrontendDesign?.lensLogo?.logoName
                                        ? currentSettings?.appFrontendDesign?.lensLogo?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'lensLogo-' + entity.id"
                            formControlName="lensLogo" (change)="uploadFile($event,'lensLogo')">
                        <hbo-field-validation fieldName="lensLogo"></hbo-field-validation>
                    </div>

                </div>
            </div>
            <div *ngIf="hasCoach()" class="row mb-3">
                <label [for]="'coachLogo'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.WELCOMEMENU.LABEL4' | translate }}
                    <hbo-field-info-icon fieldName="coachLogo"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.coachLogo?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'coachLogo')" class="clear-pb"><i
                            class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.coachLogo?.logoImage   && !(maxFileSizeExceed['coachLogo'] || fileExtError['coachLogo'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.coachLogo?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a>
                </label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'coachLogo'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.coachLogo?.logoImage &&
                                    currentSettings?.appFrontendDesign?.coachLogo?.logoName
                                    ? currentSettings?.appFrontendDesign?.coachLogo?.logoName
                                    : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'coachLogo-' + entity.id"
                            formControlName="coachLogo" (change)="uploadFile($event,'coachLogo')">
                        <hbo-field-validation fieldName="coachLogo"></hbo-field-validation>

                    </div>
                </div>
            </div>
            <!--<div *ngIf="licenseName != 'Elite' && licenseName != 'Synergy' && licenseName != 'Essential'"
                class="row mb-3">
                <label [for]="'progressiveLogo'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.WELCOMEMENU.LABEL5' | translate }}
                    <a *ngIf="currentSettings?.progressiveLogo" (click)="clearImage($event,'progressiveLogo')"
                        class="clear-pb"><i class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.progressiveLogo    && !(maxFileSizeExceed['progressiveLogo'] || fileExtError['progressiveLogo'])"
                        (click)="showImage($event, currentSettings?.progressiveLogo)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'progressiveLogo'">
                            <div>
                                <div class="label-input-file-placeholder">{{
                                    currentSettings && currentSettings.filenames &&
                                    currentSettings.filenames['progressiveLogo'] ?
                                    currentSettings.filenames['progressiveLogo']
                                    :('COMMON.UPLOADIMAGE' | translate)
                                    }}
                                </div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'progressiveLogo-' + entity.id"
                            formControlName="progressiveLogo" (change)="uploadFile($event,'progressiveLogo')">
                        <hbo-error-message
                            *ngIf="maxFileSizeExceed['progressiveLogo'] || fileExtError['progressiveLogo']"
                            [errorMessage]="(maxFileSizeExceed['progressiveLogo'] ? ('SETTING.MIMESYS.MAXFILESIZE' | translate) :'' ) + ( fileExtError['progressiveLogo'] ? ('SETTING.MIMESYS.FILEEXTERROR' | translate) : '')"
                            [className]="'fileValidation'"></hbo-error-message>
                    </div>
                </div>
            </div>-->
            <div *ngIf="!hasCoach() && apps.includes(1) && apps.length > 1"
                class="row mb-3">
                <label [for]="'progressiveLogoSubmenu'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.SUBMENULENS.LABEL1' | translate }}
                    <hbo-field-info-icon fieldName="progressiveLogoSubmenu"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage && !settingsForm.disabled"
                        (click)="clearImage($event,'progressiveLogoSubmenu')" class="clear-pb"><i
                            class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage  && !(maxFileSizeExceed['progressiveLogoSubmenu'] || fileExtError['progressiveLogoSubmenu'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'progressiveLogoSubmenu'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage &&
                                        currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoName
                                        ? currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'progressiveLogoSubmenu-' + entity.id"
                            formControlName="progressiveLogoSubmenu"
                            (change)="uploadFile($event,'progressiveLogoSubmenu')">
                        <hbo-field-validation fieldName="progressiveLogoSubmenu"></hbo-field-validation>
                    </div>
                </div>
            </div>
            <!--<div *ngIf="licenseName != 'Elite' && licenseName != 'Synergy' && licenseName != 'Essential'"
                class="row mb-3">
                <label [for]="'officeLogo'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.WELCOMEMENU.LABEL6' | translate }}
                    <a *ngIf="currentSettings?.officeLogo" (click)="clearImage($event,'officeLogo')" class="clear-pb"><i
                            class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.officeLogo   && !(maxFileSizeExceed['officeLogo'] || fileExtError['officeLogo'])"
                        (click)="showImage($event, currentSettings?.officeLogo)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'officeLogo'">
                            <div>
                                <div class="label-input-file-placeholder">{{
                                    currentSettings && currentSettings.filenames &&
                                    currentSettings.filenames['officeLogo'] ?
                                    currentSettings.filenames['officeLogo']
                                    :('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'officeLogo-' + entity.id"
                            formControlName="officeLogo" (change)="uploadFile($event,'officeLogo')">
                        <hbo-error-message *ngIf="maxFileSizeExceed['officeLogo'] || fileExtError['officeLogo']"
                            [errorMessage]="(maxFileSizeExceed['officeLogo'] ? ('SETTING.MIMESYS.MAXFILESIZE' | translate) :'' ) + ( fileExtError['officeLogo'] ? ('SETTING.MIMESYS.FILEEXTERROR' | translate) : '')"
                            [className]="'fileValidation'"></hbo-error-message>
                    </div>
                </div>
            </div>-->
            <div *ngIf="!hasCoach() && apps.includes(3) && apps.length > 1"
                class="row mb-3">
                <label [for]="'officeLogoSubmenu'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.SUBMENULENS.LABEL2' | translate }}
                    <hbo-field-info-icon fieldName="officeLogoSubmenu"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'officeLogoSubmenu')"
                        class="clear-pb"><i class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage  && !(maxFileSizeExceed['officeLogoSubmenu'] || fileExtError['officeLogoSubmenu'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'officeLogoSubmenu'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage &&
                                        currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoName
                                        ? currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'officeLogoSubmenu-' + entity.id"
                            formControlName="officeLogoSubmenu" (change)="uploadFile($event,'officeLogoSubmenu')">
                        <hbo-field-validation fieldName="officeLogoSubmenu"></hbo-field-validation>
                    </div>
                </div>
            </div>
            <div *ngIf="!hasCoach() && apps.includes(8) && apps.length > 1"
                class="row mb-3">
                <label [for]="'svisionLogoSubmenu'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.SUBMENULENS.LABEL3' | translate }}
                    <hbo-field-info-icon fieldName="svisionLogoSubmenu"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'svisionLogoSubmenu')"
                        class="clear-pb"><i class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage  && !(maxFileSizeExceed['svisionLogoSubmenu'] || fileExtError['svisionLogoSubmenu'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'svisionLogoSubmenu'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage &&
                                        currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoName
                                        ? currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'svisionLogoSubmenu-' + entity.id"
                            formControlName="svisionLogoSubmenu" (change)="uploadFile($event,'svisionLogoSubmenu')">
                        <hbo-field-validation fieldName="svisionLogoSubmenu"></hbo-field-validation>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-5 offset-1">
            <div class="mt-4 preview">
                <object [data]="previewImageWelcome()" [id]="'layoutThumbnail' + entity.id" type="image/png"></object>
                <button type="button" class="btn btn-outline-dark mt-2" (click)="preview()"><i class="bi bi-eye"></i>{{
                    'SETTING.PREVIEW' | translate }}</button>
            </div>
        </div>
    </div>

    <div *ngIf="entity.entityTypeId !== 4 && hasMultipleLensApps() && hasCoach()"
        class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">App Frontend Design - Submenu Lens</h4>
            <div class="row mb-3" *ngIf="apps.includes(1)">
                <label [for]="'progressiveLogoSubmenu'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.SUBMENULENS.LABEL1' | translate }}
                    <hbo-field-info-icon fieldName="progressiveLogoSubmenu"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage && !settingsForm.disabled"
                        (click)="clearImage($event,'progressiveLogoSubmenu')" class="clear-pb"><i
                            class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage  && !(maxFileSizeExceed['progressiveLogoSubmenu'] || fileExtError['progressiveLogoSubmenu'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'progressiveLogoSubmenu'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage &&
                                        currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoName
                                        ? currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'progressiveLogoSubmenu-' + entity.id"
                            formControlName="progressiveLogoSubmenu"
                            (change)="uploadFile($event,'progressiveLogoSubmenu')">
                        <hbo-field-validation fieldName="progressiveLogoSubmenu"></hbo-field-validation>
                    </div>
                </div>
            </div>
            <div class="row mb-3"  *ngIf="apps.includes(3)">
                <label [for]="'officeLogoSubmenu'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.SUBMENULENS.LABEL2' | translate }}
                    <hbo-field-info-icon fieldName="officeLogoSubmenu"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'officeLogoSubmenu')"
                        class="clear-pb"><i class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage  && !(maxFileSizeExceed['officeLogoSubmenu'] || fileExtError['officeLogoSubmenu'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'officeLogoSubmenu'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage &&
                                        currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoName
                                        ? currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'officeLogoSubmenu-' + entity.id"
                            formControlName="officeLogoSubmenu" (change)="uploadFile($event,'officeLogoSubmenu')">
                        <hbo-field-validation fieldName="officeLogoSubmenu"></hbo-field-validation>
                    </div>
                </div>
            </div>
            <div class="row mb-3"  *ngIf="apps.includes(8)">
                <label [for]="'svisionLogoSubmenu'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.SUBMENULENS.LABEL3' | translate }}
                    <hbo-field-info-icon fieldName="svisionLogoSubmenu"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'svisionLogoSubmenu')"
                        class="clear-pb"><i class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage  && !(maxFileSizeExceed['svisionLogoSubmenu'] || fileExtError['svisionLogoSubmenu'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'svisionLogoSubmenu'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage &&
                                        currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoName
                                        ? currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'svisionLogoSubmenu-' + entity.id"
                            formControlName="svisionLogoSubmenu" (change)="uploadFile($event,'svisionLogoSubmenu')">
                        <hbo-field-validation fieldName="svisionLogoSubmenu"></hbo-field-validation>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-5 offset-1">
            <div class="mt-4 preview">
                <object [data]="previewImageSubmenu()" [id]="'layoutThumbnail' + entity.id" type="image/png"></object>
                <button type="button" class="btn btn-outline-dark mt-2" (click)="preview('submenu')"><i
                        class="bi bi-eye"></i>{{
                        'SETTING.PREVIEW' | translate }}</button>
            </div>
        </div>
    </div>

    <!-- Distributor Logo -->
    <div *ngIf="!hideShopTemplateImages || entity.entityTypeId != 4 || (entity.entityTypeId === 4 && settingsForm.controls.distributorLogoAllow.value)"
        class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">App Frontend Design - Desk Logo</h4>
            <div class="row mb-3">
                <label [for]="'distributorLogo'" class="col-sm-5 col-form-label">
                    {{ 'SETTING.MIMESYS.WELCOMEMENU.LABEL1' | translate }}
                    <hbo-field-info-icon fieldName="distributorLogo"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.appFrontendDesign?.distributorLogo?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'distributorLogo')" class="clear-pb"><i
                            class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.appFrontendDesign?.distributorLogo?.logoImage  && !(maxFileSizeExceed['distributorLogo'] || fileExtError['distributorLogo'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.distributorLogo?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i class="bi bi-image"></i></a>
                </label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'distributorLogo'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.distributorLogo?.logoImage &&
                                        currentSettings?.appFrontendDesign?.distributorLogo?.logoName
                                        ? currentSettings?.appFrontendDesign?.distributorLogo?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'distributorLogo-' + entity.id"
                            formControlName="distributorLogo" (change)="uploadFile($event,'distributorLogo')">
                        <hbo-field-validation fieldName="distributorLogo"></hbo-field-validation>
                    </div>
                </div>
            </div>
            <div class="form-check mb-3" *ngIf="entity.entityTypeId != 4">
                <input class="form-check-input" type="checkbox" [id]="'distributorLogoAllow'" formControlName="distributorLogoAllow">
                <label class="form-check-label" [for]="'distributorLogoAllow'">
                    {{ 'SETTING.ALLOWDISTRIBUTORLOGO' | translate }}  
                </label>
            </div>
        </div>
        <div class="col-5 offset-1">
            <div class="mt-4 preview">
                <object [data]="previewImageDesk()"
                    [id]="'layoutThumbnail' + entity.id" type="image/png"></object>
                <button type="button" class="btn btn-outline-dark mt-2" (click)="preview('desk')"><i
                        class="bi bi-eye"></i>{{'SETTING.PREVIEW' | translate }}</button>
            </div>
        </div>
    </div>
    <!-- Wall Logo -->
    <div *ngIf="!hideShopTemplateImages || entity.entityTypeId != 4 || (entity.entityTypeId === 4 && settingsForm.controls.logo1Allow.value)"
        class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">App Frontend Design - Wall Logo</h4>
            <div class="row mb-3">
                <label [for]="'logo1'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.WALLLOGO.LABEL1' | translate }}
                    <hbo-field-info-icon fieldName="logo1"></hbo-field-info-icon>
                    <a *ngIf="!currentSettings?.logo1Parent && currentSettings?.appFrontendDesign?.logo1?.logoImage && (entity.entityTypeId != 4 || (entity.entityTypeId === 4 && settingsForm.controls.logo1Allow.value )) && !settingsForm.disabled"
                        (click)="clearImage($event,'logo1')" class="clear-pb"><i class="bi bi-trash"></i></a>
                    <a *ngIf="!currentSettings?.logo1Parent && currentSettings?.appFrontendDesign?.logo1?.logoImage   && !(maxFileSizeExceed['logo1'] || fileExtError['logo1'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.logo1?.logoImage)" class="image-link"
                        [ngClass]="{'only-image-link':settingsForm.disabled || (entity.entityTypeId === 4 && !settingsForm.controls.logo1Allow.value)}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7"><!--(entity.entityTypeId === 2 && settingsForm.controls.logo1Allow.value)|| -->
                    <div class="input-group custom-file-button flex-row-reverse"
                        [ngClass]="{'custom-file-button-disabled':entity.entityTypeId === 4 && !settingsForm.controls.logo1Allow.value}">
                        <label class="label-input-file" [for]="'logo1'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.logo1?.logoImage &&
                                        currentSettings?.appFrontendDesign?.logo1?.logoName
                                        ? currentSettings?.appFrontendDesign?.logo1?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'logo1-' + entity.id"
                            formControlName="logo1" (change)="uploadFile($event,'logo1')">
                        <hbo-field-validation fieldName="logo1"></hbo-field-validation>
                    </div>
                </div>
            </div>
            <div class="form-check mb-3" *ngIf="entity.entityTypeId != 4">
                <input class="form-check-input" type="checkbox" [id]="'logo1Allow'" formControlName="logo1Allow">
                <label class="form-check-label" [for]="'logo1Allow'">
                    {{ 'SETTING.ALLOW' | translate }} (1)
                </label>
            </div>
        </div>
        <div class="col-5 offset-1">
            <div class="mt-4 preview">
                <object [data]="previewImageWall()"
                    [id]="'layoutThumbnail' + entity.id" type="image/png"></object>
                <button type="button" class="btn btn-outline-dark mt-2" (click)="preview('logo1')"><i
                        class="bi bi-eye"></i>{{
                    'SETTING.PREVIEW' | translate }}</button>
            </div>
        </div>
    </div>


    <!-- Progressive Categories -->
    <!-- <div *ngIf="entity.entityTypeId != 4 && (licenseName == 'Synergy' || licenseName == 'Elite')"
        class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">Progressive Categories</h4>
            <div class="row mb-3">
                <label [for]="'progresiveBasicName'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.CATEGORIES.LABEL1' | translate }}</label>
                <div class="col-sm-7">
                    <input class="form-text-input" type="text" [id]="'progresiveBasicName'"
                        formControlName="progresiveBasicName">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'progresiveMidName'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.CATEGORIES.LABEL2' | translate }}</label>
                <div class="col-sm-7">
                    <input class="form-text-input" type="text" [id]="'progresiveMidName'"
                        formControlName="progresiveMidName">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'progresiveTopName'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.CATEGORIES.LABEL3' | translate }}</label>
                <div class="col-sm-7">
                    <input class="form-text-input" type="text" [id]="'progresiveTopName'"
                        formControlName="progresiveTopName">
                </div>
            </div>
        </div>
    </div> -->


    <!-- PDF -->
    <div *ngIf="!hideShopTemplateImages || entity.entityTypeId !=4 || entity.entityTypeId === 4 && settingsForm.controls.logo3Allow.value"
        class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">PDF DOWNLOAD</h4>
            <div class="row mb-3" *ngIf="entity.entityTypeId != 4">
                <label [for]="'template'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.PDFDOWNLOAD.LABEL1' | translate }}</label>
                <div class="col-sm-7">
                    <ng-select formControlName="template" name="template" [items]="templates" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'SETTING.MIMESYS.PDFDOWNLOAD.LABEL1' | translate}}"
                        (ngModelChange)="onChange($event,'template')">
                    </ng-select>
                </div>
            </div>
            <div [hidden]="settingsForm.controls.template.value !== 'Bi-fold-brochure' ">
                <div class="row mb-3" *ngIf="entity.entityTypeId != 4">
                    <label [for]="'coverImage'" class="col-sm-5 col-form-label">{{
                        'SETTING.MIMESYS.PDFDOWNLOAD.COVERIMAGE' | translate }} (4)
                        <hbo-field-info-icon fieldName="coverImage"></hbo-field-info-icon>
                        <a *ngIf="currentSettings?.appFrontendDesign?.coverImage?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'coverImage')"
                            class="clear-pb"><i class="bi bi-trash"></i></a>
                        <a *ngIf="currentSettings?.appFrontendDesign?.coverImage?.logoImage   && !(maxFileSizeExceed['coverImage'] || fileExtError['coverImage'])"
                            (click)="showImage($event, currentSettings?.appFrontendDesign?.coverImage?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                                class="bi bi-image"></i></a></label>
                    <div class="col-sm-7">
                        <div class="input-group custom-file-button flex-row-reverse">
                            <label class="label-input-file" [for]="'coverImage'">
                                <div>
                                    <div class="label-input-file-placeholder">
                                        {{currentSettings?.appFrontendDesign?.coverImage?.logoImage &&
                                            currentSettings?.appFrontendDesign?.coverImage?.logoName
                                            ? currentSettings?.appFrontendDesign?.coverImage?.logoName
                                            : ('COMMON.UPLOADIMAGE' | translate)
                                        }}</div>
                                    <div class="label-input-file-browse">Browse</div>
                                </div>
                            </label>
                            <input type="file" class="form-control rounded-0" [id]="'coverImage-' + entity.id"
                                formControlName="coverImage" (change)="uploadFile($event,'coverImage')">
                            <hbo-field-validation fieldName="coverImage"></hbo-field-validation>
                        </div>
                    </div>
                </div>
                <div class="row mb-3" *ngIf="entity.entityTypeId != 4">
                    <label [for]="'insidePageImage'" class="col-sm-5 col-form-label">{{
                        'SETTING.MIMESYS.PDFDOWNLOAD.INSIDEPAGEIMAGE' | translate }} (5)
                        <hbo-field-info-icon fieldName="insidePageImage"></hbo-field-info-icon>
                        <a *ngIf="currentSettings?.appFrontendDesign?.insidePageImage?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'insidePageImage')"
                            class="clear-pb"><i class="bi bi-trash"></i></a>
                        <a *ngIf="currentSettings?.appFrontendDesign?.insidePageImage?.logoImage   && !(maxFileSizeExceed['insidePageImage'] || fileExtError['insidePageImage'])"
                            (click)="showImage($event, currentSettings?.appFrontendDesign?.insidePageImage?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                                class="bi bi-image"></i></a></label>
                    <div class="col-sm-7">
                        <div class="input-group custom-file-button flex-row-reverse">
                            <label class="label-input-file" [for]="'insidePageImage'">
                                <div>
                                    <div class="label-input-file-placeholder">
                                        {{currentSettings?.appFrontendDesign?.insidePageImage?.logoImage &&
                                            currentSettings?.appFrontendDesign?.insidePageImage?.logoName
                                            ? currentSettings?.appFrontendDesign?.insidePageImage?.logoName
                                            : ('COMMON.UPLOADIMAGE' | translate)
                                        }}</div>
                                    <div class="label-input-file-browse">Browse</div>
                                </div>
                            </label>
                            <input type="file" class="form-control rounded-0" [id]="'insidePageImage-' + entity.id"
                                formControlName="insidePageImage" (change)="uploadFile($event,'insidePageImage')">
                            <hbo-field-validation fieldName="insidePageImage"></hbo-field-validation>
                        </div>
                    </div>
                </div>
                <div class="row mb-3" *ngIf="entity.entityTypeId != 4">
                    <label [for]="'color'" class="col-sm-5 col-form-label">{{
                        'SETTING.MIMESYS.PDFDOWNLOAD.COLOR' | translate }}
                    </label>
                    <div class="col-sm-7">
                        <div class="input-group custom-file-button flex-row-reverse">
                            <input type="color" class="form-control rounded-0" [id]="'color-' + entity.id"
                                formControlName="color">
                        </div>
                    </div>
                </div>
            </div>
            <div [hidden]="settingsForm.controls.template.value !== 'Standard' ">
                <div class="row mb-3" *ngIf="entity.entityTypeId != 4">
                    <label [for]="'logo2'" class="col-sm-5 col-form-label">{{
                        'SETTING.MIMESYS.PDFDOWNLOAD.LABEL2' | translate }}
                        <hbo-field-info-icon fieldName="logo2"></hbo-field-info-icon>
                        <a *ngIf="currentSettings?.appFrontendDesign?.logo2?.logoImage && !settingsForm.disabled" (click)="clearImage($event,'logo2')" class="clear-pb"><i
                                class="bi bi-trash"></i></a>
                        <a *ngIf="currentSettings?.appFrontendDesign?.logo2?.logoImage   && !(maxFileSizeExceed['logo2'] || fileExtError['logo2'])"
                            (click)="showImage($event, currentSettings?.appFrontendDesign?.logo2?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                                class="bi bi-image"></i></a></label>
                    <div class="col-sm-7">
                        <div class="input-group custom-file-button flex-row-reverse">
                            <label class="label-input-file" [for]="'logo2'">
                                <div>
                                    <div class="label-input-file-placeholder">
                                        {{currentSettings?.appFrontendDesign?.logo2?.logoImage &&
                                            currentSettings?.appFrontendDesign?.logo2?.logoName
                                            ? currentSettings?.appFrontendDesign?.logo2?.logoName
                                            : ('COMMON.UPLOADIMAGE' | translate)
                                        }}</div>
                                    <div class="label-input-file-browse">Browse</div>
                                </div>
                            </label>
                            <input type="file" class="form-control rounded-0" [id]="'logo2-' + entity.id"
                                formControlName="logo2" (change)="uploadFile($event,'logo2')">
                            <hbo-field-validation fieldName="logo2"></hbo-field-validation>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <label [for]="'logo3'" class="col-sm-5 col-form-label">{{
                        'SETTING.MIMESYS.PDFDOWNLOAD.LABEL3' | translate }}
                        <hbo-field-info-icon fieldName="logo3"></hbo-field-info-icon>
                        <a *ngIf="!currentSettings?.logo3Parent && currentSettings?.appFrontendDesign?.logo3?.logoImage && (entity.entityTypeId != 4 || (entity.entityTypeId === 4 && settingsForm.controls.logo3Allow.value)) && !settingsForm.disabled"
                            (click)="clearImage($event,'logo3')" class="clear-pb"><i class="bi bi-trash"></i></a>
                        <a *ngIf="!currentSettings?.logo3Parent && currentSettings?.appFrontendDesign?.logo3?.logoImage   && !(maxFileSizeExceed['logo3'] || fileExtError['logo3'])"
                            (click)="showImage($event, currentSettings?.appFrontendDesign?.logo3?.logoImage)" class="image-link"
                            [ngClass]="{'only-image-link':settingsForm.disabled || (entity.entityTypeId === 4 && !settingsForm.controls.logo3Allow.value)}"><i
                                class="bi bi-image"></i></a></label>
                    <div class="col-sm-7">
                        <!--(entity.entityTypeId === 2 && settingsForm.controls.logo3Allow.value)|| -->
                        <div class="input-group custom-file-button flex-row-reverse"
                            [ngClass]="{'custom-file-button-disabled':entity.entityTypeId === 4 && !settingsForm.controls.logo3Allow.value}">
                            <label class="label-input-file" [for]="'logo3'">
                                <div>
                                    <div class="label-input-file-placeholder">
                                        {{currentSettings?.appFrontendDesign?.logo3?.logoImage &&
                                            currentSettings?.appFrontendDesign?.logo3?.logoName
                                            ? currentSettings?.appFrontendDesign?.logo3?.logoName
                                            : ('COMMON.UPLOADIMAGE' | translate)
                                        }}</div>
                                    <div class="label-input-file-browse">Browse</div>
                                </div>
                            </label>
                            <input type="file" class="form-control rounded-0" [id]="'logo3-' + entity.id"
                                formControlName="logo3" (change)="uploadFile($event,'logo3')">
                            <hbo-field-validation fieldName="logo3"></hbo-field-validation>
                        </div>
                    </div>
                </div>
                <div class="form-check mb-3" *ngIf="(entity.entityTypeId === 2 || entity.entityTypeId === 3)">
                    <input class="form-check-input" type="checkbox" [id]="'logo3Allow'" formControlName="logo3Allow">
                    <label class="form-check-label" [for]="'logo3Allow'">
                        {{ 'SETTING.ALLOW' | translate }} (3)
                    </label>
                </div>
            </div>
        </div>
        <div class="col-5 offset-1">
            <div class="mt-4 preview">
                <object *ngIf="settingsForm.controls.template.value === 'Standard' "
                    data="assets/images/preview/mimesys/mimesys-pdf.svg" [id]="'layoutThumbnail' + entity.id"></object>
                <object *ngIf="settingsForm.controls.template.value === 'Bi-fold-brochure' "
                    data="assets/images/preview/mimesys/bi-fold-brochure.svg"
                    [id]="'layoutThumbnail' + entity.id"></object>
                <button type="button" class="btn btn-outline-dark mt-2" (click)="preview('pdf')"><i
                        class="bi bi-eye"></i>{{
                    'SETTING.PREVIEW' | translate }}</button>
            </div>
        </div>
    </div>

    <div *ngIf="user.roleId === 1 && (entity.entityTypeId === 1 || entity.entityTypeId === 2)" class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">RESULTS CONFIGURATION</h4>
            <div class="row mb-3">
                <label [for]="'onlyVisibleBy'" class="col-sm-10 col-form-label">{{
                    'SETTING.MIMESYS.RESULTSCONFIGURATION.LABEL1' | translate }}</label>
                <div class="col-sm-2 col-form-input-check">
                    <input class="form-check-input form-check-input-right" type="checkbox" [id]="'onlyVisibleBy'"
                        formControlName="onlyVisibleBy">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'shortTestID'" class="col-sm-6 col-form-label">{{
                    'SETTING.MIMESYS.RESULTSCONFIGURATION.LABEL2' | translate }}</label>
                <div class="col-sm-6 col-form-input-check">
                    <input class="form-check-input form-check-input-right" type="checkbox" [id]="'shortTestID'" formControlName="shortTestID">
                </div>
            </div>
        </div>
        <div class="col-5 offset-1">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">EXTERNAL COMMUNICATIONS</h4>
            <div class="row mb-3">
                <label [for]="'service'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.EXTERNALCOMMUNICATIONS.LABEL1' | translate }}</label>
                <div class="col-sm-7">
                    <ng-select formControlName="service" name="service" [items]="services" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="apiName" bindValue="apiName"
                        placeholder="{{'SETTING.MIMESYS.EXTERNALCOMMUNICATIONS.LABEL1' | translate}}"
                        (ngModelChange)="onChange($event,'service')">
                    </ng-select>
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'enabled-' + entity.id" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.EXTERNALCOMMUNICATIONS.LABEL2' | translate }}</label>
                <div class="col-sm-1 col-form-input-check">
                    <input class="form-check-input" type="checkbox" [id]="'enabled'" formControlName="enabled">
            </div>
                <label [for]="'requestToken-' + entity.id" class="col-sm-3 col-form-label"></label>
                <div class="col-sm-3 col-form-input-text">
                    <input *ngIf="settingsForm.controls.enabled.value" class="form-text-input" type="text"
                        [id]="'requestToken'" formControlName="requestToken">
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="user.roleId === 1 && (entity.entityTypeId === 1 || entity.entityTypeId === 2)"
        class="row p-4">
        <div *ngIf="user.roleId === 1" class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">ERGO CORRIDOR</h4>
            <div class="row mb-3">
                <label [for]="'ergoCorridorEnable'" class="col-sm-6 col-form-label">{{
                    'SETTING.MIMESYS.ERGOCORRIDOR.LABEL1' | translate }}</label>
                <div class="col-sm-6 col-form-input-check">
                    <input class="form-check-input form-check-input-right" type="checkbox" [id]="'ergoCorridorEnable'"
                        formControlName="ergoCorridorEnable">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'ergoCorridorLogo'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.ERGOCORRIDOR.LABEL2' | translate }}
                    <hbo-field-info-icon fieldName="ergoCorridorLogo"></hbo-field-info-icon>
                    <a *ngIf="!currentSettings?.ergoCorridorLogoParent && currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoImage && !settingsForm.disabled"
                        (click)="clearImage($event,'ergoCorridorLogo')" class="clear-pb"><i class="bi bi-trash"></i></a>
                    <a *ngIf="!currentSettings?.ergoCorridorLogoParent && currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoImage   && !(maxFileSizeExceed['ergoCorridorLogo'] || fileExtError['ergoCorridorLogo'])"
                        (click)="showImage($event, currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoImage)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-image"></i></a></label>
                <div class="col-sm-7"><!--(entity.entityTypeId === 2 && settingsForm.controls.logo1Allow.value)|| -->
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'ergoCorridorLogo'">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoImage &&
                                        currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoName
                                        ? currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoName
                                        : ('COMMON.UPLOADIMAGE' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'ergoCorridorLogo-' + entity.id"
                            formControlName="ergoCorridorLogo" (change)="uploadFile($event,'ergoCorridorLogo')">
                        <hbo-field-validation fieldName="ergoCorridorLogo"></hbo-field-validation>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'ergoCorridorName'" class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.ERGOCORRIDOR.LABEL3' | translate }}</label>
                <div class="col-sm-7">
                    <input class="form-text-input" type="text" [id]="'ergoCorridorName'"
                        formControlName="ergoCorridorName">
                </div>
            </div>
        </div>
        <div *ngIf="entity.entityTypeId === 2" class="col-5 offset-1">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">VIDEO BEFORE RESULTS</h4>
            <div class="row mb-3">
                <label [for]="'service'" class="col-sm-5 col-form-label col-form-label-nowrap">{{
                    'SETTING.MIMESYS.VIDEO.ENABLE' | translate }}</label>
                <div class="offset-md-5 col-sm-2  col-form-input-check">
                    <input class="form-check-input form-check-input-right" type="checkbox" [id]="'screenSaver-' + entity.id"
                        formControlName="screenSaverEnabled">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'screenSaverVideo-' + entity.id"class="col-sm-5 col-form-label">{{
                    'SETTING.MIMESYS.VIDEO.FILE' | translate }}
                    <hbo-field-info-icon fieldName="screenSaverVideo"></hbo-field-info-icon>
                    <a *ngIf="currentSettings?.screenSaver?.fileName && !settingsForm.disabled"
                        (click)="clearImage($event,'screenSaverVideo')" class="clear-pb"><i class="bi bi-trash"></i></a>
                    <a *ngIf="currentSettings?.screenSaverVideo   && !(maxFileSizeExceed['videoFile'] || fileExtError['videoFile'])"
                        (click)="showVideo($event, currentSettings?.screenSaverVideoData)" class="image-link" [ngClass]="{'only-image-link':settingsForm.disabled}"><i
                            class="bi bi-camera-video"></i></a>
                </label>
                <div class="col-sm-7">
                    <div class="input-group custom-file-button flex-row-reverse">
                        <label class="label-input-file" [for]="'screenSaverVideo-' + entity.id">
                            <div>
                                <div class="label-input-file-placeholder">
                                    {{currentSettings?.screenSaver?.fileName
                                    ? currentSettings?.screenSaver?.fileName
                                    :('COMMON.UPLOADVIDEO' | translate)
                                    }}</div>
                                <div class="label-input-file-browse">Browse</div>
                            </div>
                        </label>
                        <input type="file" class="form-control rounded-0" [id]="'screenSaverVideo-' + entity.id"
                            formControlName="screenSaverVideo" (change)="uploadFile($event,'screenSaverVideo')">
                        <hbo-field-validation fieldName="screenSaverVideo"></hbo-field-validation>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="user.roleId === 1 && (entity.entityTypeId === 1 || entity.entityTypeId === 2)"
        class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">CONFIGURATION OF THE PROGRESSIVE RESULTS LAYOUT</h4>
            <div class="row mb-3">
                <label [for]="'mapsDisplay'" class="col-sm-6 col-form-label">{{
                    'SETTING.MIMESYS.RESULTSLAYOUT.MAPSDISPLAY' | translate }}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="mapsDisplay" name="mapsDisplay" [items]="mapsDisplay" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'SETTING.MIMESYS.RESULTSLAYOUT.MAPSDISPLAY' | translate}}"
                        (ngModelChange)="onChange($event,'mapsDisplay')">
                    </ng-select>
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'gazeType'" class="col-sm-6 col-form-label">{{
                    'SETTING.MIMESYS.RESULTSLAYOUT.GAZETYPE' | translate }}</label>
                <div class="col-sm-6 col-form-input-check">
                    <input class="form-check-input form-check-input-right" type="checkbox" [id]="'gazeType'"
                        formControlName="gazeType">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'amplitudeRatio'" class="col-sm-6 col-form-label">{{
                    'SETTING.MIMESYS.RESULTSLAYOUT.AMPLITUDERATIO' | translate }}</label>
                <div class="col-sm-6 col-form-input-check">
                    <input class="form-check-input form-check-input-right" type="checkbox" [id]="'amplitudeRatio'"
                        formControlName="amplitudeRatio">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'maxFrequencyVector'" class="col-sm-6 col-form-label">{{
                    'SETTING.MIMESYS.RESULTSLAYOUT.MAXFREQUENCYVECTOR' | translate }}</label>
                <div class="col-sm-6 col-form-input-check">
                    <input class="form-check-input form-check-input-right" type="checkbox" [id]="'maxFrequencyVector'"
                        formControlName="maxFrequencyVector">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'diagnostic'" class="col-sm-6 col-form-label">{{
                    'SETTING.MIMESYS.RESULTSLAYOUT.DIAGNOSTIC' | translate }}</label>
                <div class="col-sm-6 col-form-input-check">
                    <input class="form-check-input form-check-input-right" type="checkbox" [id]="'diagnostic'"
                        formControlName="diagnostic">
                </div>
            </div>
            <div class="row mb-3">
                <label [for]="'additionalMapsDisplay'" class="col-sm-6 col-form-label">{{
                    'SETTING.MIMESYS.RESULTSLAYOUT.ADDITIONALMAPSDISPLAY' | translate }}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="additionalMapsDisplay" name="additionalMapsDisplay" [items]="additionalMapsDisplay" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'SETTING.MIMESYS.RESULTSLAYOUT.ADDITIONALMAPSDISPLAY' | translate}}"
                        (ngModelChange)="onChange($event,'additionalMapsDisplay')">
                    </ng-select>
                </div>
            </div>
           
        </div>
            <div *ngIf="entity.entityTypeId === 2" class="col-5 offset-1">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">3D ENVIRONMENTS</h4>
            <div class="row mb-3" *ngIf=apps.includes(1)>
                <label [for]="'enviromentLensPro'" class="col-sm-6 col-form-label">{{
                    'LensProgressive'}}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="enviromentLensPro" name="enviromentLensPro" [items]="enviromentLensPro" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'LensProgressive'}}"
                        (ngModelChange)="onChange($event,'enviromentLensPro')">
                    </ng-select>
                </div>
            </div>

            <div class="row mb-3" *ngIf=apps.includes(3)>
                <label [for]="'enviromentLensOffice'" class="col-sm-6 col-form-label">{{
                    'LensOffice' }}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="enviromentLensOffice" name="enviromentLensOffice" [items]="enviromentLensOffice" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'LensOffice'}}"
                        (ngModelChange)="onChange($event,'enviromentLensOffice')">
                    </ng-select>
                </div>
            </div>

            <div class="row mb-3" *ngIf=apps.includes(2)>
                <label [for]="'enviromentCoachProgre'" class="col-sm-6 col-form-label">{{
                    'CoachProgressive'}}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="enviromentCoachProgre" name="enviromentCoachProgre" [items]="enviromentCoachProgre" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'CoachProgressive'}}"
                        (ngModelChange)="onChange($event,'enviromentCoachProgre')">
                    </ng-select>
                </div>
            </div>

            <div class="row mb-3" *ngIf=apps.includes(4)>
                <label [for]="'enviromentCoachOffice'" class="col-sm-6 col-form-label">{{
                    'CoachOffice' }}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="enviromentCoachOffice" name="enviromentCoachOffice" [items]="enviromentCoachOffice" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'CoachOffice'}}"
                        (ngModelChange)="onChange($event,'enviromentCoachOffice')">
                    </ng-select>
                </div>
            </div>
            <div class="row mb-3" *ngIf=apps.includes(2)>
                <label [for]="'enviromentComparison'" class="col-sm-6 col-form-label">{{
                    'Comparison' }}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="enviromentComparison" name="enviromentComparison" [items]="enviromentComparison" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'Comparison'}}"
                        (ngModelChange)="onChange($event,'enviromentComparison')">
                    </ng-select>
                </div>
            </div>

            <div class="row mb-3">
                <label [for]="'enviromentLauncher'" class="col-sm-6 col-form-label">{{
                    'Launcher' }}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="enviromentLauncher" name="enviromentLauncher" [items]="enviromentLauncher" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'Launcher'}}"
                        (ngModelChange)="onChange($event,'enviromentLauncher')">
                    </ng-select>
                </div>
            </div>

            <div class="row mb-3" *ngIf=apps.includes(8)>
                <label [for]="'enviromentLensSvision'" class="col-sm-6 col-form-label">{{
                    'Single Vision' }}</label>
                <div class="col-sm-6">
                    <ng-select formControlName="enviromentLensSvision" name="enviromentLensSvision" [items]="enviromentLensSvision" [multiple]="false"
                        [searchable]="false" [clearable]="false" bindLabel="value" bindValue="value"
                        placeholder="{{'SingleVision'}}"
                        (ngModelChange)="onChange($event,'enviromentLensSvision')">
                    </ng-select>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="user.roleId === 1 && entity.entityTypeId === 2" class="row p-4">
        <div class="col-6">
            <h4 class="pb-2 mb-3 border-bottom fw-bold">APPS WITH LOGIN ALLOWED</h4>
            <div class="row mb-3">
            <label class="col-sm-4 col-form-label">Allowed Apps</label>
            <div class="col-sm-8">
                <ng-select
                    [items]="appsList"
                    [multiple]="true"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="Select apps"
                    formControlName="allowedApps"
                    [clearable]="true"
                    [searchable]="true"
                    (close)="onAllowedAppsClose()">
                </ng-select>
                <small class="text-danger" *ngIf="settingsForm.get('allowedApps')?.invalid && (settingsForm.get('allowedApps')?.dirty || settingsForm.get('allowedApps')?.touched)">
                Select at least 1 app
                </small>
            </div>
        </div>
        </div>
        <div class="col-5 offset-1"></div>
    </div>

    <div class="p-4" *ngIf="user.profileId !== 2 && !(entity.id === user.entityId && user.profileId !== 3 && !(user.roleId === 4 && user.profileId === 1))">
        <button type="button" class="btn btn-outline-secondary me-2" (click)="getSettings()">Cancel</button>
        <button type="submit" class="btn btn-dark" [disabled]="saveDisabled">{{ 'COMMON.SAVE_CHANGES' | translate
            }}</button>
    </div>
</form>
<div *ngIf="layout" class="preview-layout" (click)="preview()">
    <div (click)="preview()" class="preview-layout-close"><i class="bi bi-x-lg"></i></div>
    <object *ngIf="previewLayout!='pdf'" [data]="layoutImage()" #previewLayoutObject type="image/png"></object>
    <object *ngIf="previewLayout=='pdf' && previewLayoutPDFType=='Standard'" class="object_pdf" #previewLayoutObject
        type="image/png"></object>
    <object *ngIf="previewLayout=='pdf' && previewLayoutPDFType=='Bi-fold-brochure'" class="object_pdf_bi_fold_brochure"
        #previewLayoutObject type="image/png"></object>
    <div *ngIf="showLayoutLogos" class="preview-layout-logos-container">
        <div id="logos-logoA" *ngIf="previewLayout =='desk' && logos?.logoA" class="layout-logo"
            [style.top.px]="logos.logoA[static_images.folder].y" [style.left.px]="logos.logoA[static_images.folder].x" [style.width.px]="logos.logoA[static_images.folder].w"
            [style.height.px]="logos.logoA[static_images.folder].h">
            <img *ngIf="currentSettings?.appFrontendDesign?.distributorLogo?.logoImage" [src]="currentSettings?.appFrontendDesign?.distributorLogo?.logoImage"
                (load)="getLogosPosition()" />
            <span
                *ngIf="!currentSettings?.appFrontendDesign?.distributorLogo?.logoImage"><!--{{'SETTING.MIMESYS.NOLOGOSHORT.LABEL1' | translate }}--></span>
        </div>
        <div id="logos-logoB"
            *ngIf="(!previewLayout || (previewLayout =='submenu' && hasLens() && hasCoach())) && logos?.logoB"
            class="layout-logo" [style.top.px]="logos.logoB.y" [style.left.px]="logos.logoB.x"
            [style.width.px]="logos.logoB.w" [style.height.px]="logos.logoB.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage" [src]="currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage"
                (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage"><!--{{'SETTING.MIMESYS.NOLOGOSHORT.LABEL2' | translate
                }}--></span>
        </div>
        <div id="logos-logoC"
            *ngIf="(!previewLayout && logos?.logoC && hasCoach())|| (previewLayout=='submenu' && hasLens() && hasCoach())"
            class="layout-logo" [style.top.px]="logos.logoC.y" [style.left.px]="logos.logoC.x"
            [style.width.px]="logos.logoC.w" [style.height.px]="logos.logoC.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.lensLogo?.logoImage" [src]="currentSettings?.appFrontendDesign?.lensLogo?.logoImage" (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.lensLogo?.logoImage">{{'SETTING.MIMESYS.NOLOGOSHORT.LABEL3' | translate }}</span>
        </div>
        <div id="logos-logoD"
            *ngIf="!previewLayout && logos?.logoD && hasCoach()"
            class="layout-logo" [style.top.px]="logos.logoD.y" [style.left.px]="logos.logoD.x"
            [style.width.px]="logos.logoD.w" [style.height.px]="logos.logoD.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.coachLogo?.logoImage" [src]="currentSettings?.appFrontendDesign?.coachLogo?.logoImage" (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.coachLogo?.logoImage">{{'SETTING.MIMESYS.NOLOGOSHORT.LABEL4' | translate }}</span>
        </div>

        <div id="logos-logoE"
            *ngIf="((!previewLayout && logos?.logoE && !hasCoach() && hasMultipleLensApps()) || (previewLayout =='submenu' && apps.includes(1) && hasMultipleLensApps() && logos?.logoE))"
            class="layout-logo" [style.top.px]="logos.logoE.y" [style.left.px]="logos.logoE.x"
            [style.width.px]="logos.logoE.w" [style.height.px]="logos.logoE.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage" [src]="currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage"
                (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage">{{'SETTING.MIMESYS.NOLOGOSHORT.LABEL5' | translate
                }}</span>
        </div>
        <div id="logos-logoF"
            *ngIf="((!previewLayout && logos?.logoF && apps.includes(3) && !hasCoach())  || (previewLayout =='submenu' && hasLens() && hasCoach() && apps.includes(3) && logos?.logoF ))"
            class="layout-logo" [style.top.px]="logos.logoF.y" [style.left.px]="logos.logoF.x"
            [style.width.px]="logos.logoF.w" [style.height.px]="logos.logoF.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage" [src]="currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage"
                (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage">{{'SETTING.MIMESYS.NOLOGOSHORT.LABEL6' | translate
                }}</span>
        </div>
        <div id="logos-logoG"
            *ngIf="((!previewLayout && logos?.logoG && apps.includes(8) && !hasCoach())  || (previewLayout =='submenu' && hasLens() && hasCoach() && apps.includes(8) && logos?.logoG ))"
            class="layout-logo" [style.top.px]="logos.logoG.y" [style.left.px]="logos.logoG.x"
            [style.width.px]="logos.logoG.w" [style.height.px]="logos.logoG.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage" [src]="currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage"
                (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage">{{'SETTING.MIMESYS.NOLOGOSHORT.LABEL7' | translate
                }}</span>
        </div>
        <!--<div *ngIf="logos?.window" class="window-data">
        <div>{{ 'x: '+ logos.window.x}}</div>
        <div>{{ 'y: '+ logos.window.y}}</div>
        <div>{{ 'w: '+ logos.window.w}}</div>
        <div>{{ 'h: '+ logos.window.h}}</div>
        <div>{{ 'object x: '+ logos.object.x}}</div>
        <div>{{ 'object y: '+ logos.object.y}}</div>
        <div>{{ 'object w: '+ logos.object.w}}</div>
        <div>{{ 'object h: '+ logos.object.h}}</div>
        <img [src]="currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage" width="200" height="200" />
    </div>-->
        <!--Wall Logo-->
        <div id="logos-logo1" *ngIf="previewLayout=='logo1' && logos?.logo1" class="layout-logo"
            [style.top.px]="logos.logo1[static_images.folder].y" [style.left.px]="logos.logo1[static_images.folder].x" [style.width.px]="logos.logo1[static_images.folder].w"
            [style.height.px]="logos.logo1[static_images.folder].h">
            <img *ngIf="currentSettings?.appFrontendDesign?.logo1?.logoImage" [src]="currentSettings?.appFrontendDesign?.logo1?.logoImage" (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.logo1?.logoImage">{{'SETTING.MIMESYS.WALLLOGO.LABEL1' | translate }}</span>
        </div>

        <div id="logos-logo2" *ngIf="previewLayout=='pdf' && logos?.logo2 && previewLayoutPDFType=='Standard'"
            class="layout-logo" [style.top.px]="logos.logo2.y" [style.left.px]="logos.logo2.x"
            [style.width.px]="logos.logo2.w" [style.height.px]="logos.logo2.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.logo2?.logoImage" [src]="currentSettings?.appFrontendDesign?.logo2?.logoImage" (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.logo2?.logoImage">{{'SETTING.MIMESYS.PDFDOWNLOAD.LABEL2' | translate }}</span>
        </div>

        <div id="logos-logo3" *ngIf="previewLayout=='pdf' && logos?.logo3 && previewLayoutPDFType=='Standard'"
            class="layout-logo" [style.top.px]="logos.logo3.y" [style.left.px]="logos.logo3.x"
            [style.width.px]="logos.logo3.w" [style.height.px]="logos.logo3.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.logo3?.logoImage" [src]="currentSettings?.appFrontendDesign?.logo3?.logoImage" (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.logo3?.logoImage">{{'SETTING.MIMESYS.PDFDOWNLOAD.LABEL3' | translate }}</span>
        </div>

        <div id="coverImage"
            *ngIf="previewLayout=='pdf' && logos?.coverImage && previewLayoutPDFType=='Bi-fold-brochure'"
            class="layout-logo" [style.top.px]="logos.coverImage.y" [style.left.px]="logos.coverImage.x"
            [style.width.px]="logos.coverImage.w" [style.height.px]="logos.coverImage.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.coverImage?.logoImage" [src]="currentSettings?.appFrontendDesign?.coverImage?.logoImage" (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.coverImage?.logoImage">{{'SETTING.MIMESYS.PDFDOWNLOAD.COVERIMAGE' | translate }}</span>
        </div>

        <div id="insidePageImage"
            *ngIf="previewLayout=='pdf' && logos?.insidePageImage && previewLayoutPDFType=='Bi-fold-brochure'"
            class="layout-logo" [style.top.px]="logos.insidePageImage.y" [style.left.px]="logos.insidePageImage.x"
            [style.width.px]="logos.insidePageImage.w" [style.height.px]="logos.insidePageImage.h">
            <img *ngIf="currentSettings?.appFrontendDesign?.insidePageImage?.logoImage" [src]="currentSettings?.appFrontendDesign?.insidePageImage?.logoImage"
                (load)="getLogosPosition()" />
            <span *ngIf="!currentSettings?.appFrontendDesign?.insidePageImage?.logoImage">{{'SETTING.MIMESYS.PDFDOWNLOAD.INSIDEPAGEIMAGE' | translate
                }}</span>
        </div>


    </div>
</div>